// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Utils.localDraftGeocodingStatus_decode;

let FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

let FormStateFragment_localDraftMlsStatus_decode = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Utils.localDraftMlsStatus_decode;

let FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Utils.localDraftMlsStatus_fromString;

let FormStateFragment = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useIsValid(draft, formState) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.node, convertFragment, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.node, convertFragment$1, formState);
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let match$1 = PropertyWizardRelayUtils.FormUtils.noneIfEmpty(draft$1.draftProperty.address);
  let match$2 = draft$1.draftProperty.selectedArea;
  let match$3 = formState$1.geocodingStatus;
  let match$4 = formState$1.mlsStatus;
  let exit = 0;
  if (match$1 === undefined) {
    return {
      NAME: "Invalid",
      VAL: "missingAddress"
    };
  }
  if (match$2 === undefined) {
    return {
      NAME: "Invalid",
      VAL: "missingCity"
    };
  }
  let label = match$2.label;
  switch (match$3) {
    case "Valid" :
      switch (match$4) {
        case "OnMls" :
          if (mode !== "New") {
            return {
              NAME: "Valid",
              VAL: [
                match$1,
                label
              ]
            };
          }
          exit = 1;
          break;
        case "NotOnMls" :
        case "OnMlsButAllowed" :
          return {
            NAME: "Valid",
            VAL: [
              match$1,
              label
            ]
          };
        default:
          exit = 1;
      }
      break;
    case "Error" :
      return {
        NAME: "Invalid",
        VAL: "geocodingFailed"
      };
    default:
      exit = 1;
  }
  if (exit === 1) {
    let exit$1 = 0;
    switch (match$3) {
      case "ErrorDuplicateListing" :
        return {
          NAME: "Invalid",
          VAL: "duplicateListing"
        };
      case "ErrorOutsideChapterBoundaries" :
        return {
          NAME: "Invalid",
          VAL: "outsideChapterBoundaries"
        };
      default:
        if (match$4 === "OnMls") {
          if (mode === "New") {
            return {
              NAME: "Invalid",
              VAL: "propertyAlreadyOnMls"
            };
          }
          exit$1 = 2;
        } else {
          exit$1 = 2;
        }
    }
    if (exit$1 === 2) {
      if (match$4 === "Error") {
        return {
          NAME: "Invalid",
          VAL: "mlsStatusCheckFailed"
        };
      } else {
        return;
      }
    }
  }
}

let StreetAddress = {
  DraftFragment: DraftFragment,
  FormStateFragment: FormStateFragment,
  useIsValid: useIsValid
};

let convertFragment$2 = PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.node, convertFragment$2, fRef);
}

let DraftFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

let convertFragment$3 = PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.node, convertFragment$3, fRef);
}

let FormStateFragment_localDraftGeocodingStatus_decode$1 = PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.Utils.localDraftGeocodingStatus_decode;

let FormStateFragment_localDraftGeocodingStatus_fromString$1 = PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

let FormStateFragment$1 = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode$1,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function useIsValid$1(draft, formState) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.node, convertFragment$2, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.node, convertFragment$3, formState);
  let match = draft$1.draftProperty.selectedArea;
  let match$1 = formState$1.geocodingStatus;
  if (match === undefined) {
    if (match$1 === "Called") {
      return;
    } else {
      return {
        NAME: "Error",
        VAL: "is required"
      };
    }
  }
  switch (match$1) {
    case "NotCalled" :
    case "Called" :
      return;
    case "Valid" :
      return "Valid";
    default:
      return {
        NAME: "Error",
        VAL: ""
      };
  }
}

let CityOrZip = {
  DraftFragment: DraftFragment$1,
  FormStateFragment: FormStateFragment$1,
  useIsValid: useIsValid$1
};

let convertFragment$4 = PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.node, convertFragment$4, fRef);
}

let DraftFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

let convertFragment$5 = PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.node, convertFragment$5, fRef);
}

let FormStateFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function useIsValid$2(draft, formState) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.node, convertFragment$4, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.node, convertFragment$5, formState);
  let isStreetAddressValid = useIsValid(draft$1.fragmentRefs, formState$1.fragmentRefs);
  let isCityOrZipValid = useIsValid$1(draft$1.fragmentRefs, formState$1.fragmentRefs);
  if (typeof isStreetAddressValid === "object" && isStreetAddressValid.NAME === "Invalid") {
    return "Invalid";
  }
  if (typeof isCityOrZipValid === "object" && isCityOrZipValid.NAME === "Error") {
    return "Invalid";
  } else {
    return "Valid";
  }
}

let FormUtils;

exports.FormUtils = FormUtils;
exports.StreetAddress = StreetAddress;
exports.CityOrZip = CityOrZip;
exports.DraftFragment = DraftFragment$2;
exports.FormStateFragment = FormStateFragment$2;
exports.useIsValid = useIsValid$2;
/* RescriptRelay_Fragment Not a pure module */
